var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoney = function SvgMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 214,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#22582D",
    d: "M1.032 156.156 248.98 40.682l71.014 34.584L100.853 204.78z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A9C43",
    d: "m0 129.18 113.479-59.403C157.795 46.579 206.297 0 206.297 0l106.014 51.005s8.285 3.067-74.045 62.863-138.445 63.937-138.445 63.937z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "money_svg__a",
    width: 313,
    height: 178,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2A9C43",
    d: "m0 129.18 113.479-59.403C157.795 46.579 206.297 0 206.297 0l106.014 51.005s8.285 3.067-74.045 62.863-138.445 63.937-138.445 63.937z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#money_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    d: "M196.498 117.701c21.102-9.828 21.244-26.058.317-36.252s-54.998-10.49-76.099-.663-21.244 26.058-.317 36.252 54.998 10.49 76.099.663"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#247F37",
    d: "m140.101 95.553 9.346-5.39-8.985-9.292-9.346 5.39c-6.152 3.547-7.118 10.585-2.157 15.717 1.637 1.692 3.727 2.97 5.99 3.783-.753-3.886 1.028-7.83 5.152-10.208M149.1 104.86c-4.124 2.378-9.526 2.577-14.137.915.379 1.921 1.359 3.818 2.995 5.51 4.962 5.132 13.974 6.415 20.128 2.868l9.345-5.389-8.985-9.293zM176.791 103.364l-9.346 5.389 8.986 9.292 9.345-5.388c6.154-3.549 7.12-10.586 2.157-15.718-1.635-1.692-3.727-2.97-5.988-3.783.752 3.886-1.03 7.83-5.154 10.208M167.807 94.072c4.125-2.378 9.526-2.577 14.137-.916-.379-1.92-1.359-3.817-2.995-5.509-4.962-5.132-13.974-6.416-20.126-2.868l-9.347 5.39 8.985 9.292z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3B58E3",
    d: "M17.917 116.748 43.77 97.62l113.603 55.437-29.923 17.589z"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#247F37",
    d: "m0 129.197 99.815 48.609v35.785L0 162.473z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#29903F",
    d: "M99.786 177.805 320 75.265v32.708l-220.214 105.6z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "money_svg__b",
    width: 221,
    height: 139,
    x: 99,
    y: 75,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#29903F",
    d: "M99.786 177.805 320 75.265v32.708l-220.214 105.6z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#money_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#446CED",
    d: "M155.196 151.59h-33.723v64.062h33.723z"
  }))));
};
export default SvgMoney;